import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const SharingOffIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg {...props} ref={ref} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'>
        <path fill='currentColor' d='M15 18a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2h10ZM.793.793a1 1 0 0 1 1.414 0l16.97 16.97.07.077a1 1 0 0 1-1.407 1.407l-.076-.07L15.586 17H2a2 2 0 0 1-2-2V5a2 2 0 0 1 1.622-1.964l-.829-.83a1 1 0 0 1 0-1.413ZM18 3a2 2 0 0 1 2 2v10c0 .316-.076.614-.206.88L18 14.086V5H8.914l-2-2H18ZM2 5v10h11.586l-10-10H2Z'/>
    </svg>
));
